import { DatePipe, KeyValue, KeyValuePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit, signal } from '@angular/core';
import { NgbModal, NgbModalModule, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Backend } from 'src/app/backend-interface/backend';
import { UtcPipe } from 'src/app/pipes/format.pipe';
import { Policy, RequestPolicy } from 'src/app/service/global.service';
import { ToastService } from 'src/app/service/toast.service';
import { TranslationService } from 'src/app/service/translation.service';
import { forkJoin } from 'rxjs';
import { ToastComponent } from 'src/app/components/toast/toast.component';
import { FiltersSpComponent } from 'src/app/components/filters/filters-sp/filters-sp.component';
import { FormAddPolicyAndSimulationComponent } from '../form-add-policy-and-simulation/form-add-policy-and-simulation.component';
import { LoadingErrorComponent } from 'src/app/components/loading-error/loading-error.component';
import { DetailsPolicyComponent } from '../details-policy/details-policy.component';
import Keycloak from 'keycloak-js';


@Component({
  selector: 'app-simulation',
  templateUrl: './simulation.component.html',
  styleUrls: ['./simulation.component.scss'],
  standalone: true,
  providers: [UtcPipe, DatePipe, TranslationService, ToastService, NgbModal],
  imports: [
    TranslateModule,
    NgbModalModule,
    ToastComponent,
    FiltersSpComponent,
    KeyValuePipe,
    FormAddPolicyAndSimulationComponent,
    LoadingErrorComponent,
    DetailsPolicyComponent
]
})
export class SimulationComponent implements OnInit {

  lSimulatePolicies: Policy[] = [];
  mapPolicies = new Map<string, Policy[]>();
  currentpolicy?: Policy;
  predId: string = "";
  modalref ?: NgbModalRef;
  readonly translationService = inject(TranslationService);
  readonly toastService = inject(ToastService);
  readonly keycloak = inject(Keycloak);
  readonly utcpipe = inject(UtcPipe);
  readonly datepipe = inject(DatePipe);
  readonly modalService = inject(NgbModal);

  readonly loadingOerror = signal<boolean>(true);
  filterBwv: string[] = [];
  filterClient: string[] = [];

  ngOnInit() {
    this.initAsync();
  }

  private async initAsync() {
    this.lSimulatePolicies = await Backend.POLICIES.getPoliciesByFilters(["CREATED", "DESACTIVATED"], this.filterBwv, this.filterClient);
    if (this.keycloak.hasRealmRole('bo-dip-wl-admin')) {
      await this.getPoliciesFromClient();
    } else {
      this.getPoliciesFromOs();
    }
    await this.loading(0.5);
    if (!this.toastService.isEmpty()) {
      await new Promise(r => setTimeout(r, 5000));
    }
  }

  async filterByFilters(event: { bwvs: number[]; clients: number[] }) {
    const stringEvent = {
      bwvs: event.bwvs.map(String),
      clients: event.clients.map(String)
    };
    this.filterBwv = stringEvent.bwvs;
    this.filterClient = stringEvent.clients;
    await this.reloadData();
  }

  today(): number {
    return Date.now();
  }

  timestampToDate(time: string) {
    const timestamp = this.utcpipe.transform(time);
    return Backend.FORMAT.timestampToDate(timestamp.getTime(), this.datepipe, this.translationService.getDatePipeLang()) ?? '';
  }

  horaire(time: string) {
    const timestamp = this.utcpipe.transform(time);
    return Backend.FORMAT.horaire(timestamp.getTime(), this.datepipe);
  }

  lOsApp() {
    return Backend.POLICIES.osApp(this.lSimulatePolicies);
  }

  getPoliciesFromOs() {
    for (const os of Backend.POLICIES.getAllOS(this.lSimulatePolicies)) {
      this.mapPolicies.set(os, Backend.POLICIES.getPolicyByOS(os, this.lSimulatePolicies));
    }
  }

  async getClients() {
    return await Backend.POLICIES.getClients();
  }

  async getPoliciesFromClient() {
    const lPolWithClient = this.lSimulatePolicies.filter(p => p.clientPolicyDto);
    const lPolWithoutClient = this.lSimulatePolicies.filter(p => !p.clientPolicyDto);
    const lClients = await this.getClients();
    for (const client of lClients) {
      const lPClient = Backend.POLICIES.getPolicyByClient(client.name, lPolWithClient);
      if (lPClient.length > 0) {
        this.mapPolicies.set(client.name, lPClient);
      }
    }
    this.translationService.get('others').subscribe(other => {
      this.mapPolicies.set(other, lPolWithoutClient);
    });
  }

  supprEsp(str: string) {
    return str.replaceAll(' ', '');
  }

  originalOrder = (a: KeyValue<string, Policy[]>, b: KeyValue<[string, string] | string, Policy[]>): number => {
    return 0;
  }

  policySelectionnee(policy: Policy) {
    this.currentpolicy = policy;
    const del = document.getElementById("actifElem");
    if (del) {
      del.removeAttribute('id');
      del.setAttribute('id', this.predId);
    }
    const el = document.getElementById("elem" + this.supprEsp(policy.name.toLowerCase()) + policy.id);
    if (el) {
      el.id = "actifElem";
      this.predId = "elem" + this.supprEsp(policy.name.toLowerCase()) + policy.id;
    }
    document.getElementById('policyInfos')?.removeAttribute('hidden');
  }

  scroolTo() {
    document.getElementById('policyInfos')?.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
  }

  async editPolicy(event: { policy: Policy, toast: string }) {
    if (event.policy.id) {
      const request: RequestPolicy = {
        id: event.policy.id,
        name: event.policy.name,
        idBW: event.policy.bwVersion!.id,
        activatedDetectors: event.policy.activatedDetectors
      };
      if (this.keycloak.hasRealmRole('bo-dip-wl-admin')) {
        request.clientName = event.policy.clientPolicyDto?.name;
      }
      try {
        await Backend.POLICIES.modifyPolicy(request);
        this.toastService.show(event.toast, { classname: 'bg-success', delay: 5000 });
      } catch (error) {
        const err = error as HttpErrorResponse;
        this.toastService.show(err.error.error, { classname: 'bg-danger', delay: 5000 });
      }
    }
    this.lSimulatePolicies = await Backend.POLICIES.getPoliciesByFilters(["CREATED", "DESACTIVATED"], this.filterBwv, this.filterClient);
    await this.reloadData();
  }

  public async getPolicyID(policy: Policy) {
    if (policy.id) {
      this.currentpolicy = await Backend.POLICIES.getPolicyById(policy.id);
    }
  }

  openCenteredVertically({ content }: { content: any }) {
    this.modalref = this.modalService.open(content, { centered: true });
  }

  async reloadData() {
    this.mapPolicies = new Map();
    this.loadingOerror.set(true);
    this.ngOnInit();
    this.hidePolicyDetails();
  }

  hidePolicyDetails() {
    const policyInfos = document.getElementById('policyInfos');
    if (policyInfos) {
      policyInfos.removeAttribute('hidden');
      policyInfos.setAttribute('hidden', 'hidden');
    }
  }

  async addPolicies(event: { policy: Policy, toast: string, nameClient?: string }) {
    const request: RequestPolicy = {
      name: event.policy.name,
      idBW: event.policy.bwVersion!.id,
      clientName: event.nameClient,
      activatedDetectors: event.policy.activatedDetectors
    };
    try {
      await Backend.POLICIES.postPolicy(request);
      this.toastService.show(event.toast, { classname: 'bg-success', delay: 5000 });
      await this.reloadData();
      const fp = this.lSimulatePolicies.find(elem => elem.name == event.policy.name);
      if (fp) {
        this.policySelectionnee(fp);
        this.scroolTo();
      }
    } catch (error) {
      const err = error as HttpErrorResponse;
      this.toastService.show(err.error.error, { classname: 'bg-danger', delay: 5000 });
    }
  }

  async deleteP(p: Policy) {
    try {
      await Backend.POLICIES.deletePolicy(p.id);

      forkJoin({
        policy: this.translationService.get('security-policies-toast-policy'),
        delete: this.translationService.get('security-policies-toast-delete')
      }).subscribe(translations => {
        this.toastService.show(
          `${translations.policy}${p.name}${translations.delete}`,
          { classname: 'bg-success', delay: 5000 }
        );
      });
    } catch (error) {
      const err = error as HttpErrorResponse;
      this.toastService.show(err.error.error, { classname: 'bg-danger', delay: 5000 });
    }
    await this.reloadData();
  }

  async submit(event: { policy: Policy, applicationId: number }) {
    try {
      await Backend.POLICIES.patchStatusPolicy(event.policy.id, { status: 'SUBMITTED', idApplication: event.applicationId, sendMail: true });
      forkJoin({
        policy: this.translationService.get('security-policies-toast-policy'),
        submit: this.translationService.get('security-policies-toast-submit')
      }).subscribe(translations => {
        this.toastService.show(
          `${translations.policy}${event.policy.name}${translations.submit}`,
          { classname: 'bg-success', delay: 5000 }
        );
      })
    } catch (error) {
      const err = error as HttpErrorResponse;
      this.toastService.show(err.error.error, { classname: 'bg-danger', delay: 5000 });
    }
    await this.reloadData();
  }

  async loading(n: number) {
    await new Promise(r => setTimeout(r, n * 1000));
    this.loadingOerror.set(false);
  }
}
